import Modal from "bootstrap/js/dist/modal";
import {
    Management,
    b64Uri,
    getElement,
    getJson,
    loadInputInteger,
    resetForm,
    setSelect2Ajax,
    formatCurrency,
    getData,
    requestOptions,
    bodyRequest,
    tryAsyncFetch,
    alertHTML,
} from "../../../../../helpers";

export class PaymentmethodModal extends HTMLDivElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
        const Form = getElement("[data-form=form]", this);

        this.addEventListener("click", (e) => {
            const Target = e.target;
            const BtnAdd = Target.closest(".add");
            const BtnRemove = Target.closest(".remove");

            if (Target.name == "need_bank") {
                if (parseInt(Target.value)) {
                    Form.elements.purchasesaccount_id.removeAttribute(
                        "required"
                    );
                    Form.elements.salesaccount_id.removeAttribute("required");
                } else {
                    Form.elements.purchasesaccount_id.setAttribute(
                        "required",
                        ""
                    );
                    Form.elements.salesaccount_id.setAttribute("required", "");
                }
            }

            if (BtnAdd) {
                const Tr = BtnAdd.closest("tr");
                const Tr2 = Tr.cloneNode(true);
                const P = Tr.parentElement;
                Tr2.querySelectorAll("input").forEach(
                    (item) => (item.value = "")
                );
                P.appendChild(Tr2);

                loadInputInteger();
            }

            if (BtnRemove) {
                const Tr = BtnRemove.closest("tr");
                const P = Tr.parentElement;

                if (P.children.length > 1) {
                    P.removeChild(Tr);
                }
            }

            /**
             * Solución modal anidados bootstrap
             */
            const CloseModal = e.target.closest("[data-bs-dismiss=modal]");

            if (CloseModal) {
                const BD = document.querySelectorAll(".modal-backdrop");

                BD?.forEach((item) => {
                    item.remove();
                });
                const OldModal = getElement(
                    getData(CloseModal, "data-modal-target")
                );

                if (OldModal) {
                    const M = new Modal(OldModal, {});
                    M.show();
                }
            }
        });

        this.addEventListener("input", (e) => {
            const T = e.target;
        });

        Form.elements.save.addEventListener("click", async () => {
            if (Form.reportValidity()) {
                if (getData(Form.elements.save, "data-request") == "http") {
                    Form.submit();
                } else {
                    let body = new FormData(Form);
                    requestOptions.body = body;
                    let response = await tryAsyncFetch(
                        Form.action,
                        requestOptions
                    );
                    requestOptions.body = bodyRequest; // regresar el bodyRequest predeterminado

                    if (response.errors) {
                        alertHTML(response.message);
                    } else {
                        Form.elements.closeModal.click();
                        alertHTML(getData(Form, "data-message"), "success");
                        // El modo pro solo si lo piden, aquí lanzar un custom event para devolver la data y poder setear el target
                    }
                }
            }
        });
    }

    static create(modal, title, url, message = null) {
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        const Days = Array.from(getElement(modal).querySelectorAll(".remove"));
        Days.shift();
        Days.forEach((item) => item.click());
        if (message) {
            Form.setAttribute("data-message", message);
        }
    }

    static edit(modal, title, url, data, type) {
        data = getJson(b64Uri(data, "decode"));
        let Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        Form.elements.name.value = data.name;

        if (data.days.length) {
            const D = getElement("[name='days[]']", getElement(modal));
            const Tr = D.closest("tr");
            const P = Tr.parentElement;
            P.innerHTML = "";

            data.days.forEach((item) => {
                const Tr2 = Tr.cloneNode(true);
                Tr2.querySelector("[name='days[]']").value = item.days;
                Tr2.querySelector("[name='amounts[]']").value = formatCurrency(
                    item.amount,
                    "decimal"
                );
                // Tr2.querySelector("[name='types[]']").value = item.type;
                P.appendChild(Tr2);
            });
            Tr.remove();

            loadInputInteger();
        }

        Form.elements.description.value = data.description;
        Array.from(Form.elements.need_bank).find(
            (item) => item.value == data.need_bank
        ).checked = true;

        if (data.need_bank) {
            Form.elements.salesaccount_id.removeAttribute("required");
            Form.elements.purchasesaccount_id.removeAttribute("required");
        }

        setSelect2Ajax(Form.elements.type, data.type, type);

        let managament = data.managements.find(
            (item) => item.company_id == Management.company_id
        );

        if (managament) {
            // dataAccounting.concat = [];

            if (managament.pivot.salesaccount) {
                setSelect2Ajax(
                    Form.elements.salesaccount_id,
                    managament.pivot.salesaccount.id,
                    `${managament.pivot.salesaccount.number} - ${managament.pivot.salesaccount.name}`
                );

                // dataAccounting.concat["salesaccount_id"] =
                //     managament.pivot.salesaccount.id;
            }

            if (managament.pivot.purchasesaccount) {
                setSelect2Ajax(
                    Form.elements.purchasesaccount_id,
                    managament.pivot.purchasesaccount.id,
                    `${managament.pivot.purchasesaccount.number} - ${managament.pivot.purchasesaccount.name}`
                );

                // dataAccounting.concat["purchasesaccount_id"] =
                //     managament.pivot.purchasesaccount.id;
            }

            // dataAccounting.accountingplans = Object.values(
            //     dataAccounting.concat
            // );
        }
    }
}

window.customElements.define("paymentmethod-modal", PaymentmethodModal, {
    extends: "div",
});
